module.exports = __webpack_public_path__ + "img/電気回路_4_8_5.adceacec.png";